import AsyncStorage from '@react-native-async-storage/async-storage'
import { languages, type Language } from './generated/i18n-meta'

export const LANGUAGE_STORAGE_KEY = '__tolgee_currentLanguage'

function isSupportedLanguage(value: string | null): value is Language {
  return value !== null && languages.includes(value as Language)
}

export async function getPersistedLanguage(): Promise<Language | null> {
  if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') {
    const storedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY)

    if (isSupportedLanguage(storedLanguage)) {
      return storedLanguage
    }
  }

  try {
    const stored = await AsyncStorage.getItem(LANGUAGE_STORAGE_KEY)

    if (isSupportedLanguage(stored)) {
      return stored
    }
  } catch {
  }

  return null
}
